import { render, staticRenderFns } from "./kgrid.vue?vue&type=template&id=35435d58&scoped=true"
import script from "./kgrid.vue?vue&type=script&lang=js"
export * from "./kgrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35435d58",
  null
  
)

export default component.exports